import Swal from 'sweetalert2';
import { Theme } from '@radix-ui/themes';
import { Provider } from 'react-redux';
import withReactContent from 'sweetalert2-react-content';
import { ThemeProvider } from 'styled-components';
import { QueryClientProvider } from '@tanstack/react-query';

import airboTheme from '../../themes/airbo';
import queryClient from '../../lib/queryClient';
import store from '../../lib/redux/store';
import styles from './Modal.module.css';

const ReactSwal = withReactContent(Swal);

export default function Modal({
  component,
  width,
  padding = '20px',
  allowOutsideClick = true,
  allowEscapeKey = true,
}) {
  return ReactSwal.fire({
    // SweetAlert renders this outside the app's React tree, so it needs its own
    // Radix Theme (same settings as the app root in entrypoints/application.jsx)
    // or Radix tokens such as --radius-3 and --space-2 are undefined in here.
    html: (
      <Theme
        appearance="light"
        accentColor="blue"
        panelBackground="solid"
        hasBackground={false}
        className={styles.theme}
      >
        <Provider store={store}>
          <ThemeProvider theme={airboTheme}>
            <QueryClientProvider client={queryClient}>
              {component}
            </QueryClientProvider>
          </ThemeProvider>
        </Provider>
      </Theme>
    ),
    showConfirmButton: false,
    allowOutsideClick,
    allowEscapeKey,
    width,
    padding,
  });
}
